<mat-card class="simulations-block">
    <mat-card-header>
        <mat-card-title>
            <h2>
                1. {{ (isMJP ? 
                    'dashboard.simulationsList.title.mjp.shortLabel' : 
                    'dashboard.simulationsList.title.default.shortLabel') | translate}}
                <app-tooltip text="{{(isMJP ? 
                    'dashboard.simulationsList.title.mjp.summary' : 
                    'dashboard.simulationsList.title.default.summary') | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-year-select-form [years]="years" [userOrigin]="userOrigin"></app-year-select-form>

        <mat-tab-group class="simulations-lists" color="accent" animationDuration="0ms">
            <mat-tab label="{{(isMJP ? 
                'dashboard.simulationsList.listsNames.template.mjp.shortLabel' : 
                'dashboard.simulationsList.listsNames.template.default.shortLabel') | translate}}">
                <div class="tab-content">
                    <app-partitioning-list [partitioningsList]="partitioningsList" [visibility]="visibilityType.template" [isMJP]="isMJP"></app-partitioning-list>
                </div>
            </mat-tab>
            <mat-tab label="{{'dashboard.simulationsList.listsNames.user.shortLabel' | translate}}">
                <div class="tab-content">
                    <app-partitioning-list [partitioningsList]="partitioningsList" [visibility]="visibilityType.perso" [isMJP]="isMJP"></app-partitioning-list>
                </div>
            </mat-tab>
            <mat-tab label="{{'dashboard.simulationsList.listsNames.shared.shortLabel' | translate}}">
                <div class="tab-content">
                    <app-partitioning-list [partitioningsList]="partitioningsList" [visibility]="visibilityType.shared" [isMJP]="isMJP"></app-partitioning-list>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>
